<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span v-if="editing">Счет – {{ entry.name }}</span>
                    <span v-else>Создать счет</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Название"
                            v-model="entry.name"
                            :errors="errors.name"
                            required
                        />

                        <text-field
                            class="w-1/2 px-2"
                            title="Банк"
                            v-model="entry.bank"
                            :errors="errors.bank"
                            required
                        />
                    </div>

                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Номер счета"
                            v-model="entry.number"
                            :errors="errors.number"
                            required
                        />

                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Баланс"
                            v-model="entry.balance"
                            :errors="errors.balance"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <router-link
                        class="btn btn-warning"
                        :to="{
                            name: 'admin.billing.withdrawal.accounts.form',
                            params: {id: this.entry.id}
                        }"
                    >Снять средства</router-link>
                    <button class="btn btn-primary">Сохранить</button>

                    <button v-if="editing" @click.prevent="destroy" class="btn btn-danger">Удалить</button>
                </form>
            </div>

            <transactions
                v-if="can('access-transactions') && editing"
                modelType="account"
                :modelId="entry.id"
            />
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Transactions from "../../../admin/billing/transactions/index";

export default {
    extends: ResourceForm,

    components: {
        Transactions
    },

    data() {
        return {
            resource: {
                name: "admin.assets.accounts",
                endpoint: "admin/assets/accounts"
            }
        };
    },

    methods: {},

    mounted() {}
};
</script>
